import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import styled from '@emotion/styled'

/**
 * 標題與提醒元件
 * @param {*} children - 標題，當有 'children' 與 'title' 同時存在，'children' 優先採用
 * @param {*} title - 標題
 * @param {string} [variant='h5'] - 標題文字大小（Default 'h5'）
 * @param {*} [remark] - 提醒（Optional）
 */
const TitleWithRemark = ({
  children,
  title,
  remark,
  variant = 'h5',
  color,
  titleId,
  remarkId,
  ...rest
}) => (
  <Box display="flex" flexWrap="wrap" alignItems="center" {...rest}>
    <Typography variant={variant}>
      <Box mr={1} fontWeight="fontWeightBold" color={color} id={titleId}>
        {children ? children : title}
      </Box>
    </Typography>

    {remark && (
      <Typography
        component="span"
        variant="subtitle1"
        color="textSecondary"
        id={remarkId}
      >
        {remark}
      </Typography>
    )}
  </Box>
)

export default TitleWithRemark
